import { buildConductEntriesForSchoolAggregateListPath } from '../../generated/schooly-api-v1/api-paths';

export const getConductEntriesAggregatePath = buildConductEntriesForSchoolAggregateListPath;
